(function () {
  const COOKIE_NAME = 'canopy_customer_type';
  const DISMISS_COOKIE = 'canopy_customer_type_dismissed';
  const FIELD_NAME = 'attributes[customer_type]';
  const DEFAULT_COOKIE_HOURS = 24 * 90; // 90 days
  const DEFAULT_DISMISS_HOURS = 24 * 30; // 30 days
  const FOREVER_HOURS = 24 * 365 * 10;
  const VALID = ['residential', 'commercial'];

  /* ---------------- cookies ---------------- */

  function setCookie(name, value, hours) {
    const span = hours > 0 ? hours : FOREVER_HOURS;
    const expires = new Date(Date.now() + span * 3600000).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : '';
  }

  function storedType() {
    const value = getCookie(COOKIE_NAME);
    return VALID.indexOf(value) !== -1 ? value : '';
  }

  function popupCookieHours() {
    const popup = document.querySelector('[data-ct-popup]');
    if (!popup) return DEFAULT_COOKIE_HOURS;
    const hours = parseFloat(popup.dataset.cookieHours);
    return isNaN(hours) ? DEFAULT_COOKIE_HOURS : hours;
  }

  /* ---------------- cart ---------------- */

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function syncFields(value) {
    document.querySelectorAll('[name="' + FIELD_NAME + '"]').forEach(function (field) {
      field.value = value;
    });
  }

  function syncChoiceButtons(value) {
    document.querySelectorAll('[data-ct-choice]').forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.ctChoice === value);
    });
  }

  function pushToCart(value) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { customer_type: value } }),
    }).catch(function (error) {
      console.error('[customer-type] cart update failed:', error);
    });
  }

  function apply(value) {
    syncFields(value);
    syncChoiceButtons(value);
    return pushToCart(value);
  }

  /* --------- catch every AJAX add-to-cart --------- */

  const nativeFetch = window.fetch;

  // Resolve the request URL whether fetch() was given a string, a URL object or a Request.
  function requestUrl(target) {
    if (!target) return '';
    if (typeof target === 'string') return target;
    if (target.url) return target.url; // Request
    try {
      return String(target); // URL object
    } catch (e) {
      return '';
    }
  }

  window.fetch = function () {
    const args = arguments;
    const url = requestUrl(args[0]);
    // Always call native fetch on window — avoids "Illegal invocation" if another
    // script (e.g. a GTM tag) calls fetch bound to a different object.
    const promise = nativeFetch.apply(window, args);

    if (url && url.indexOf('/cart/add') !== -1) {
      promise
        .then(function (response) {
          const value = storedType();
          if (response && response.ok && value) apply(value);
        })
        .catch(function () {});
    }

    return promise;
  };

  /* --------- sync from real cart state --------- */

  function syncFromCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const cartValue =
          cart.attributes && VALID.indexOf(cart.attributes.customer_type) !== -1
            ? cart.attributes.customer_type
            : '';

        if (cartValue) {
          // Cart already has a value (e.g. set from another tab/session) — trust it.
          syncFields(cartValue);
          syncChoiceButtons(cartValue);
          return;
        }

        // Cart has no value yet — push the cookie's value in, if any.
        const cookieValue = storedType();
        if (cookieValue && cart.item_count > 0) {
          return apply(cookieValue);
        }

        if (cookieValue) {
          syncFields(cookieValue);
          syncChoiceButtons(cookieValue);
        }
      })
      .catch(function () {});
  }

  function syncOnLoad() {
    const value = storedType();
    if (value) {
      syncFields(value);
      syncChoiceButtons(value);
    }
    // Always verify against the actual cart — corrects any stale DOM,
    // including selects that were sitting inert in a hidden drawer/section.
    syncFromCart();
  }

  /* ---------------- popup ---------------- */

  function initPopup() {
    const popup = document.querySelector('[data-ct-popup]');
    if (!popup) return;
    if (storedType() || getCookie(DISMISS_COOKIE)) return;

    const dismissHours = parseFloat(popup.dataset.dismissHours);
    const dismissFor =
      isNaN(dismissHours) || dismissHours <= 0 ? DEFAULT_DISMISS_HOURS : dismissHours;

    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      popup.hidden = false;
      popup.classList.add('is-open');
      document.body.classList.add('overflow-hidden');

      const first = popup.querySelector('[data-ct-choice]');
      if (first) first.focus();
    }

    function close() {
      popup.classList.remove('is-open');
      popup.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-ct-choice]')) {
        close();
        return;
      }

      if (event.target.closest('[data-ct-close]')) {
        setCookie(DISMISS_COOKIE, '1', dismissFor);
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        setCookie(DISMISS_COOKIE, '1', dismissFor);
        close();
      }
    });

    const delay = parseInt(popup.dataset.delay, 10);
    setTimeout(open, (isNaN(delay) ? 0 : delay) * 1000);
  }

  /* ---------- shared: popup buttons ---------- */

  document.addEventListener('click', function (event) {
    const choiceBtn = event.target.closest('[data-ct-choice]');
    if (!choiceBtn) return;

    const value = choiceBtn.dataset.ctChoice;
    if (VALID.indexOf(value) === -1) return;

    setCookie(COOKIE_NAME, value, popupCookieHours());
    apply(value);

    document.dispatchEvent(
      new CustomEvent('customer-type:selected', { detail: { value: value } })
    );
  });

  /* ---------- shared: cart drawer / cart page dropdowns ---------- */

  document.addEventListener('change', function (event) {
    const select = event.target;
    if (!select.matches('.js-cart-customer-type')) return;

    const value = select.value;
    if (value && VALID.indexOf(value) === -1) return;

    if (value) {
      setCookie(COOKIE_NAME, value, popupCookieHours());
    }
    apply(value);

    document.dispatchEvent(
      new CustomEvent('customer-type:selected', { detail: { value: value } })
    );
  });

  /* ---------------- boot ---------------- */

  function init() {
    syncOnLoad();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Handles bfcache restores (e.g. browser back button from checkout),
  // where the page reappears without re-running Liquid or firing DOMContentLoaded.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      syncFromCart();
    }
  });

  // Cart drawer / cart section re-render after quantity changes.
  document.addEventListener('cart:refresh', function () {
    const value = storedType();
    if (value) {
      syncFields(value);
      syncChoiceButtons(value);
    }
  });
})();
